import { Pipe, PipeTransform } from "@angular/core";
import { METERS_IN_KILOMETER } from "@dtm-frontend/shared/utils";
import { TranslocoService } from "@jsverse/transloco";

const FRACTION_DIGITS = 2;

@Pipe({
    name: "distance",
})
export class DistancePipe implements PipeTransform {
    constructor(private readonly translocoService: TranslocoService) {}

    public transform(value: number | string | undefined | null, units: "meters" | "nauticalMiles" = "meters"): string | undefined {
        if (value === undefined || value === null) {
            return undefined;
        }

        if (units === "nauticalMiles") {
            return this.translocoService.translate("dtmUi.distanceInNauticalMiles", { value: Number(value).toFixed(FRACTION_DIGITS) });
        }

        const roundedValue = Math.round(+value);

        if (+value < METERS_IN_KILOMETER) {
            return this.translocoService.translate("dtmUi.distanceInMeters", { value: roundedValue });
        }

        return this.translocoService.translate("dtmUi.distanceInKilometers", {
            value: (roundedValue / METERS_IN_KILOMETER).toFixed(FRACTION_DIGITS),
        });
    }
}
